import React from 'react';
import { ILaunchPadApp } from '@app/models/launchpadApp.model';
import LaunchPadApp from '@app/pages/launchPad/components/apps/app/LaunchPadApp.component';

interface IProps {
    apps: ILaunchPadApp[];
    handleRefreshPage: Function;
}

const LaunchpadApps: React.SFC<IProps> = ({ apps, handleRefreshPage}) => {

    const list = apps.map((app, index) => <LaunchPadApp app={app} key={index} handleRefreshPage={handleRefreshPage} />);

    return (
        <div className={'launchpad__list'}>
            {list}
        </div>
    );
};

export default LaunchpadApps;
